module.exports = __webpack_public_path__ + "img/pr-13.f5f9f48f.png";